export default __webpack_public_path__ + "static/media/bg-waves-mid.1c4905aa.png";